import React, { FunctionComponent, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import styles from './ChipItem.module.scss';

interface Props {
    id?: string;
    name: string;
    img?: string;
    onDelete?: () => void;
}

export const ChipItem: FunctionComponent<Props> = props => {
    const [showDeleteButton, setShowDeleteButton] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 1280px)');

        const updateDeleteVisibility = () => {
            setShowDeleteButton(mediaQuery.matches);
        };

        updateDeleteVisibility();
        mediaQuery.addEventListener('change', updateDeleteVisibility);

        return () => {
            mediaQuery.removeEventListener('change', updateDeleteVisibility);
        };
    }, []);

    const mouseEnterHandler = () => {
        if (props.onDelete) {
            setShowDeleteButton(true);
        }
    };

    const mouseLeaveHandler = () => {
        if (props.onDelete && !window.matchMedia('(max-width: 1280px)').matches) {
            setShowDeleteButton(false);
        }
    };

    return (
        <div
            id={props.id}
            className={styles.chip}
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
        >
            {props.img && (
                <span className={styles.imageWrapper}>
                    <img
                        src={props.img}
                        alt=""
                        className={styles.image}
                    />
                </span>
            )}
            <span className={styles.label}>{props.name}</span>
            {props.onDelete && showDeleteButton && (
                <button
                    type="button"
                    className={styles.deleteButton}
                    onClick={props.onDelete}
                    aria-label={`Remove ${props.name}`}
                >
                    <FontAwesomeIcon
                        icon={faTimes}
                        className={styles.deleteIcon}
                    />
                </button>
            )}
        </div>
    );
};

export default ChipItem;
